export const kioskGroupsResource = {
  name: 'Kiosk groups',
  fields: {
    name: 'Name',
    description: 'Description',
    memberCount: 'Kiosks',
    updatedAt: 'Updated',
    kiosk: 'Kiosk',
    site: 'Site',
    status: 'Status',
    addedAt: 'Added',
  },
  testGroup: 'Test group',
  testGroupHelp: 'Kiosks in the test group get new releases first, and only a rollout to the test group can go to every kiosk at once. One group at a time is the test group.',
  replaceTestGroupConfirm: 'This makes %{group} the test group. %{current} will stop being the test group.',
  kioskCount: '%{smart_count} kiosk |||| %{smart_count} kiosks',
  removeTestGroupConfirm: 'With no test group, only urgent rollouts can be created until another group is made the test group.',
  members: 'Kiosks in this group',
  noMembers: 'No kiosks in this group yet.',
  membersNote: 'Changing the kiosks in a group does not change rollouts that already exist. A rollout keeps the kiosks the group had when it was created. If all of those kiosks are later disabled or deleted, the rollout never finishes and blocks other rollouts to them; cancel it.',
  actions: {
    new: 'New group',
    create: 'Create group',
    save: 'Save',
    chooseKiosks: 'Choose kiosks',
    delete: 'Delete group',
  },
  deleteConfirm: 'Delete this group? Rollouts that already exist keep their kiosks.',
  saved: 'Saved',
  deleted: 'Group deleted',
};

export const kioskGroups = kioskGroupsResource;
